const STATUS_PAGE_URL = 'https://status.transfeera.com/api/v2';

export default {
  getIncidents: () => fetch(STATUS_PAGE_URL + '/incidents.json', {}).then(resp => resp.json()),
  getUpcomingScheduledMaintenances: () =>
    fetch(STATUS_PAGE_URL + '/scheduled-maintenances/upcoming.json', {}).then(resp => resp.json()),
  getActiveScheduledMaintenances: () =>
    fetch(STATUS_PAGE_URL + '/scheduled-maintenances/active.json', {}).then(resp => resp.json())
};
